import { createAsyncThunk } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";
import { fetchWrapper } from "_utils";
import { PORTAL_KEY as name } from "constants/labels";

const baseUrl = `${process.env.REACT_APP_API_URL_ENERGY_ASSISTANCE}/api/energy-assistance`;
const baseURLAccount = `${process.env.REACT_APP_API_URL}/api/energy-assistance`

export const getProfileInfoApi = createAsyncThunk(
  `${name}/getProfileInfo`,
  async (AccountNumber, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/profile-information`, {
          Data: { AccountNumber },
        })
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCurrentBillingApi = createAsyncThunk(
  `${name}/getCurrentBilling`,
  async (AccountNumber, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/current-bill`, {
          Data: { AccountNumber },
        })
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEnergyUsageApi = createAsyncThunk(
  `${name}/getEnergyUsage`,
  async (AccountNumber, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/energy-usage`, {
          Data: { AccountNumber },
        })
      );
      const { Succeeded, Errors, Message: message } = response;
      // if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getGrantInfoApi = createAsyncThunk(
  `${name}/getGrantInfo`,
  async (AccountNumber, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/grant-information`, {
          Data: { AccountNumber },
        })
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const postReconnectServiceApi = createAsyncThunk(
  `${name}/reconnectService`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/reconnect-service`, { Data: payload })
      );
      const { Succeeded, Errors } = response;
      if (!Succeeded && Errors.length)
        throw new Error("Error: network response failed.");
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAccountLookupApi = createAsyncThunk(
  `${name}/getAccountLookup`,
  async (AccountNumber, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/account-search`, {
          Data: { AccountNumber },
        })
      );
      const { Succeeded, Errors, Message: message } = response;

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAdvanceSearchApi = createAsyncThunk(
  `${name}/getAdvanceSearch`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/advance-search`, {
          Data: payload,
        })
      );
      const { Succeeded, Errors, Message: message } = response;

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getReportAccountBalanceApi = createAsyncThunk(
  `${name}/getReportAccountBalance`,
  async (accountNumbers, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/report/account-balance`, {
          Data: { accountNumbers },
        })
      );
      
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getBillPaymentHistoryApi = createAsyncThunk(
  `${name}/billingAndPaymentHistory`,
  async (AccountNumber, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/billing-payment-history`, {
          Data: { AccountNumber },
        })
      );
      const { Succeeded, Errors, Data: data, Message: message } = response;
      if (!Succeeded && Errors.length)
        throw new Error("Error: network response failed.");
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getReportEnergyUsageApi = createAsyncThunk(
  `${name}/getReportEnergyUsage`,
  async (accountNumbers, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/report/energy-usage`, {
          Data: { accountNumbers },
        })
      );
      const { Succeeded, Errors, Message: message } = response;
      //if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getBillPaymentPDFApi = createAsyncThunk(
  `${name}/billPaymentPDF`,
  async (data, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/bill-details/download`, {
          Data: data,
        })
      );
      const { Succeeded, Errors } = response;
      if (!Succeeded && Errors.length)
        throw new Error("Error: network response failed.");
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCurrentBillPDFApi = createAsyncThunk(
  `${name}/currentBillPDF`,
  async (data, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/current-bill/download`, {
          Data: data,
        })
      );
      const { Succeeded, Errors } = response;
      if (!Succeeded && Errors.length)
        throw new Error("Error: network response failed.");
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTooltipMsgsApi = createAsyncThunk(
  `${name}/getTooltipMsgs`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/tooltip-msgs`)
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getJurisdictionApi = createAsyncThunk(
  `${name}/getJurisdiction`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/manage-seasons/jurisdictions`)
      );
      
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getManageSeasonApi = createAsyncThunk(
  `${name}/getManageSeason`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/manage-seasons`)
      );
      
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createSeasonApi = createAsyncThunk(
  `${name}/createSeason`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/manage-seasons/create`, payload)
      );
     
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateSeasonApi = createAsyncThunk(
  `${name}/updateSeason`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/manage-seasons/update`, payload)
      );
      
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteSeasonApi = createAsyncThunk(
  `${name}/deleteSeason`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.delete(`${baseUrl}/manage-seasons/delete`, payload)
      );
      
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEmergencyHoldApi = createAsyncThunk(
  `${name}/emergencyHold`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/emergency-hold`, {
          Data: payload,
        })
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEmergencyHoldStatusApi = createAsyncThunk(
  `${name}/emergencyHoldStatus`,
  async (AccountNumber, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/emergency-hold/status`, {
          Data: { AccountNumber },
        })
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getReportSampleFileApi = createAsyncThunk(
  `${name}/getReportSampleFile`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/report/sample-file`)
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAgencyListApi = createAsyncThunk(
  `${name}/agencies`,
  async (AccountNumber, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/agencies`, {
          Data: { AccountNumber: AccountNumber ?? null },
        })
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const postPledgeAmountApi = createAsyncThunk(
  `${name}/pledgeAmount`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/pledge-amount`, { Data: payload })
      );
      const { Succeeded, Errors } = response;

      return response;
    } catch (error) {
     return rejectWithValue(error);
    }
  }
);

export const postOutstandingGrantReportsApi = createAsyncThunk(
  `${name}/outstandingGrantReports`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/report/outstanding-grants/filter`, {
          Data: payload,
        })
      );
      const { Succeeded, Errors, Message: message } = response;

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getOutstandingGrantReportsApi = createAsyncThunk(
  `${name}/getOutstandingGrantReports`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/report/outstanding-grants`)
      );
      const { Succeeded, Errors, Message: message } = response;

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAvailableAppointmentsApi = createAsyncThunk(
  `${name}/getAvailableAppointments`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(
          `${baseUrl}/reconnect-service/available-appointments`,
          { Data: payload }
        )
      );
      const { Succeeded, Errors, Message: message } = response;

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Get all agencies
export const getEAAgenciesApi = createAsyncThunk(
  `${name}/getAgencies`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseURLAccount}/manage-agency`)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Create a new agency
export const createEAAgencyApi = createAsyncThunk(
  `${name}/createAgency`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseURLAccount}/manage-agency/create`, payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Update an existing agency
export const updateEAAgencyApi = createAsyncThunk(
  `${name}/updateAgency`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseURLAccount}/manage-agency/update`, payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Delete agency/manage-agency
export const deleteEAAgencyApi = createAsyncThunk(
  `${name}/deleteAgency`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.delete(`${baseURLAccount}/manage-agency/delete`, payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getReportEnergyUsageMonthlyApi = createAsyncThunk(
  `${name}/getReportEnergyUsageMonthly`,
  async (accountNumbers, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/report/energy-usage/monthly`, {
          Data: { accountNumbers },
        }),
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getReportEnergyUsageAnnualApi = createAsyncThunk(
  `${name}/getReportEnergyUsageAnnual`,
  async (accountNumbers, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/report/energy-usage/annual`, {
          Data: { accountNumbers },
        }),
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getReconnectionRequestReportApi = createAsyncThunk(
  `${name}/getReconnectionRequestReport`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/report/reconnection-reqs`, {
          Data: payload,
        }),
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getPledgeAmountReportApi = createAsyncThunk(
  `${name}/getPledgeAmountReport`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/report/pledge-amount`, {
          Data: payload,
        }),
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getEmergencyHoldReportApi = createAsyncThunk(
  `${name}/getEmergencyHoldReport`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/report/emergency-hold`, {
          Data: payload,
        }),
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
